export default __webpack_public_path__ + "static/media/058-mushrooms.75987710.svg";